export default function TextField({
  field,
  value = "",
  onChange,
  error,
  disabled,
}) {
  return (
    <div className="dynamic-field-control">
      <label className="dynamic-field-control__label" htmlFor={field.key}>
        {field.label}
        {field.required && (
          <span className="dynamic-field-control__required">*</span>
        )}
      </label>

      {field.description && (
        <p className="dynamic-field-control__description">
          {field.description}
        </p>
      )}

      <input
        id={field.key}
        type="text"
        value={value || ""}
        placeholder={field.placeholder || ""}
        disabled={disabled}
        className={`dynamic-field-control__input ${
          error ? "dynamic-field-control__input--error" : ""
        }`}
        onChange={(e) => onChange(field.key, e.target.value)}
      />

      {field.help_text && (
        <p className="dynamic-field-control__help">{field.help_text}</p>
      )}
      {error && <span className="dynamic-field-control__error">{error}</span>}
    </div>
  );
}
